import { FC, useEffect } from 'react';
import { Switch } from 'antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { SwitchProps } from 'antd/lib/switch';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';

export interface SearchFormSwitchProps extends BaseSearchFormItemProps {
  /** switch Props */
  switchProps?: SwitchProps;
}
/** 开关 */
export const SearchFormSwitch: FC<SearchFormSwitchProps> = props => {
  const {
    switchProps,
    isDetail,
    form,
    name,
    initialValue,
    isTable,
    testId,
    label,
    render,
    disabledRender,
    ...resProps
  } = props;
  useEffect(() => {
    if (typeof name === 'string') {
      form?.setFieldsValue({ [name]: !!initialValue });
    }
  }, [initialValue]);
  const handleRender = (checked: any) => {
    if (checked === undefined) return TABLE_COLUMN_EMPTY;
    if (checked) return switchProps?.checkedChildren || '是';
    return switchProps?.unCheckedChildren || '否';
  };
  return (
    <SearchFormItem
      name={name}
      initialValue={initialValue}
      valuePropName="checked"
      label={label}
      {...resProps}
    >
      {isDetail || (switchProps && switchProps.disabled) ? (
        <SearchFormDisabled
          name={name}
          // isSwitch={true}
          form={form}
          isTable={isTable}
          render={render || disabledRender || handleRender}
        />
      ) : (
        <Switch {...switchProps} test-id={`${testId}-${name}`} />
      )}
    </SearchFormItem>
  );
};

SearchFormSwitch.displayName = SearchFormItemEnum.SearchFormSwitch;

export default SearchFormSwitch;
